import React from 'react';
import { StarberrySiteProvider, useModule } from '@starberry/components';
import BaseDefinitions from 'base/definitions';
import { default as Routes } from '../../routes';
import { Helmet } from 'react-helmet';

import './page.css';

const definitions = process.env.GATSBY_CUSTOMTHEME
  ? require(`../../custom/${process.env.GATSBY_CUSTOMTHEME}/definitions`).default
  : BaseDefinitions;

const Module = ({ module }) => {
  const Module = useModule(module);
  if (!Module) {
    return null;
  }
  return <Module />;
};

const Layout = (props) => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>My Account</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
      </Helmet>
      <StarberrySiteProvider definitions={definitions}>
        <Module module={Routes[props.pageContext.slug]} />
      </StarberrySiteProvider>
    </>
  );
};

export default Layout;
